import type { ReactNode } from 'react';

import type { Color } from './styles';
import { SvgRoot } from './styles';

export type SvgIconProps = {
    color?: Color;
    size?: string;
    ariaLabel?: string;
    children?: ReactNode;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

const SvgIcon = ({ color = 'inherit', size = 'inherit', ariaLabel = undefined, children, ...props }: SvgIconProps) => (
    <SvgRoot
        color={color}
        size={size}
        {...props}
        aria-hidden={ariaLabel ? undefined : true}
        role={ariaLabel ? 'img' : undefined}
        aria-label={ariaLabel}
        viewBox="0 0 20 20"
    >
        {children}
    </SvgRoot>
);
export default SvgIcon;
